import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { ISelectOption, Select } from 'components/forms/Selects'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { closeDialog } from 'utils/actions/ui'
import { updateShipmentAccessorials } from 'utils/api/shipmentAcessorials'
import {
  APPROVAL_DIALOG,
  REJECTION_DIALOG,
  MAP_REJECTION_REASONS,
  REJECTION_REASON,
} from 'apps/detention-review/constants/detention'
import { IDetentionShipment, IVariant } from 'apps/detention-review/utils/types'
import { ConfirmationModal } from 'transfix-ui'

interface IRequestFormProps {
  accessorialId?: string
  onConfirm: (value: string) => void
  amount: string
  openDialog: () => void
  shipment: IDetentionShipment
  variant: IVariant
  showTCRinput: boolean
  trailerControlRecord: string
}

export const DetentionDialog = React.memo<IRequestFormProps>(
  ({
    accessorialId = '',
    amount,
    onConfirm,
    shipment,
    showTCRinput,
    trailerControlRecord,
    variant,
  }) => {
    const dispatch = useDispatch()
    const [rejectionReason, setRejectionReason] = useState<REJECTION_REASON | undefined>(undefined)
    const [error, setError] = useState<string>('')

    const { label, message, state, title } = variant
    const isTCRRequired = showTCRinput && !trailerControlRecord
    const isApprovedDisabled = isTCRRequired
    const isRejectedDisabled = !rejectionReason
    const isApproveDialog = variant === APPROVAL_DIALOG
    const isSaveDisabled = isApproveDialog ? isApprovedDisabled : isRejectedDisabled

    const onSelect = ({ value }: ISelectOption<REJECTION_REASON>) => setRejectionReason(value)
    const closeDetentionDialog = () => dispatch(closeDialog())
    const handleSave = async () => {
      onConfirm(state)

      const group = state === REJECTION_DIALOG.state ? 'reject' : 'approve'
      const body = rejectionReason ? { rejectionReason } : undefined
      try {
        await updateShipmentAccessorials(accessorialId, group, body)
        closeDetentionDialog()
      } catch (e) {
        setError(e)
      }
    }

    return (
      <ConfirmationModal
        title={title}
        size={8}
        open
        onClose={closeDetentionDialog}
        actions={[
          {
            label: 'Cancel',
            type: 'dismiss',
          },
          {
            label: `${label}`,
            type: 'confirm',
            action: handleSave,
            disabled: isSaveDisabled,
            dataTest: 'submit-detention-dialog',
          },
        ]}>
        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <span>
              {message} ${amount} detention payment for Shipment #{shipment.id}
            </span>
          </div>
        </div>
        {variant?.state === REJECTION_DIALOG.state && (
          <div className='row mt3'>
            <div className='col-md-8 col-xs-12'>
              <Select
                id='reason'
                label='Select a Reason'
                options={MAP_REJECTION_REASONS}
                value={rejectionReason}
                onChange={onSelect}
              />
            </div>
          </div>
        )}
        <div className='row mb2'>
          {error && (
            <InlineMessage message={error} type={INLINE_MESSAGE_VARIANTS.ALERT} className='mt2' />
          )}
          {isApproveDialog && isApprovedDisabled && (
            <InlineMessage
              message='Please enter a Trailer Control Record to Approve'
              type={INLINE_MESSAGE_VARIANTS.ALERT}
              className='mt2'
            />
          )}
          {!isApproveDialog && isRejectedDisabled && (
            <InlineMessage
              message='Please select a rejection reason to Reject'
              type={INLINE_MESSAGE_VARIANTS.ALERT}
              className='mt2'
            />
          )}
        </div>
      </ConfirmationModal>
    )
  }
)
